// assets
import { IconBrandChrome, IconHelp, IconSitemap, IconLogout } from '@tabler/icons';

// constant
const icons = {
    IconBrandChrome: IconBrandChrome,
    IconHelp: IconHelp,
    IconSitemap: IconSitemap,
    IconLogout: IconLogout,
};

//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'myapi.view_logout',
            title: 'Logout',
            type: 'item',
            url: '/logout',
            icon: icons['IconLogout'],
            breadcrumbs: false
        },
        
    ]
};
